import {
    Component,
    OnInit,
    ViewEncapsulation,
    Input,
    EventEmitter,
    Output
} from '@angular/core';

@Component({
    selector: 'bb-datepicker',
    template: require('./datepicker.component.html'),
    styles: [
        require('./datepicker.component.css'),
    ],
    encapsulation: ViewEncapsulation.None,
})
export class DatepickerComponent implements OnInit {

    public dateValue : Date;
    public fi: any;
    public tr: any;

    @Input() public inline : boolean = false;
    @Input() public change : any;
    @Input() public styleClass : string = '';
    @Input() public get date() {
        return this.dateValue;
    }
    public set date(date) {

        this.dateValue = date;
        this.dateChange.emit(date);
    }

    @Output() public dateChange = new EventEmitter();

    public ngOnInit() {
        this.fi = {
            firstDayOfWeek: 1,
            monthNames: [
                'Tammikuu',
                'Helmikuu',
                'Maaliskuu',
                'Huhtikuu',
                'Toukokuu',
                'Kesäkuu',
                'Heinäkuu',
                'Elokuu',
                'Syyskuu',
                'Lokakuu',
                'Marraskuu',
                'Joulukuu'
            ],
            monthNamesShort: [
                'Tammi',
                'Helmi',
                'Maalis',
                'Huhti',
                'Touko',
                'Kesä',
                'Heinä',
                'Elo',
                'Syys',
                'Loka',
                'Marras',
                'Joulu'
            ],
            dayNamesShort: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'Su'],
            dayNames: ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai'],
            dayNamesMin: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
        };

        this.tr = {
            firstDayOfWeek : 1
        };
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader??ref--7-0!./src/app/datepicker/datepicker.component.ts